import { getTranslatedString } from 'helpers/i18n';

export const requiredRule = {
  required: true,
  message: getTranslatedString('requiredField'),
};
